<ftr-animated-remote
  [remote]="viewModel"
  [successTemplate]="success"
  [loadingTemplate]="loading"
  [failureTemplate]="failure"
>
  <ng-template #success let-data>
    <ftr-collapsible-list
      expandText="View all permissions"
      collapseText="Collapse all permissions"
      [items]="data"
      [itemTemplate]="itemTemplate"
      [trackBy]="trackBy"
    >
      <ng-template #itemTemplate let-permission>
        <ftr-user-group-permissions-list-item [permission]="permission"></ftr-user-group-permissions-list-item>
      </ng-template>
    </ftr-collapsible-list>
  </ng-template>
  <ng-template #loading>
    <ftr-line-loader message="Loading permissions list"></ftr-line-loader>
  </ng-template>
  <ng-template #failure>
    <ftr-error-retry
      text="Failed to load the permissions list. Please try again."
      [icon]="false"
      (retry)="refresh.next()"
    ></ftr-error-retry>
  </ng-template>
</ftr-animated-remote>
